
import { FirearmAssignmentEntityDecoratorBase } from './firearm-assignment.decorator.base';


export class FirearmAssignmentEntityDecorator extends FirearmAssignmentEntityDecoratorBase {
  constructor() {
    super();
  }
}



